// extracted by mini-css-extract-plugin
export default {"textInput":"styles_textInput__4p4RN","form":"styles_form__ZnKRl","formDiv":"styles_formDiv__b3HJg","clientView":"styles_clientView__rIeUd","ui-spin":"styles_ui-spin__v0sFo"};